import * as Yup from "yup";
import ValidationErrorMessage from "../../../components/formcontrols/ValidationErrorMessage";
import AutoCompleteFormControl from "../../../components/formcontrols/AutoCompleteFormControl";
import { stringDateToyyyyMMdd } from "../../../util/date";
import { getPatchOperations } from "../../../util/form";
import { validationMessages } from "../../../constants/validation";

export const personForsikringForm = (
  queryValues: IFormControlGenericQueryValues,
  personId: string,
  personForsikringId?: string,
): FormConfig<PersonForsikringDTO> => {
  const query = `person/${personId}/forsikringer/`;
  return {
    title: "forsikring",
    lockedValues: [
      {
        id: "personId",
        value: personId,
      },
      {
        id: "forsikringsId",
        value: personForsikringId,
      },
    ],
    validationSchema: Yup.object({
      forsikringsselskabId: Yup.string().required("Forsikringsselskab mangler"),
      policeNr: Yup.string().required("Policenr mangler"),
      periodeFraDato: Yup.date().nullable().required("Startdato skal være sat"),
      periodeTilDatoInklusiv: Yup.date()
        .nullable()
        .transform((_currValue, originalValue) =>
          originalValue === null || originalValue === ""
            ? null
            : new Date(originalValue),
        )
        .test(
          "dateEndBeforeStart",
          validationMessages.dateEndBeforeStart,
          function () {
            const { periodeFraDato, periodeTilDatoInklusiv } = this.parent;
            if (!periodeTilDatoInklusiv) return true;
            return periodeTilDatoInklusiv >= periodeFraDato;
          },
        ),
      garantiordning: Yup.boolean().required("Garantiordning skal være sat"),
      restance: Yup.boolean().required("Restance skal være sat"),
      notat: Yup.string(),
    }),
    form: [
      {
        component: "custom",
        customComponent: ({ touched, value, error, onChange }) => {
          return (
            <>
              <label className="form-label">Forsikring</label>
              <AutoCompleteFormControl
                className={touched && error ? "is-invalid" : ""}
                onChange={onChange}
                value={value}
                queryValues={queryValues}
              />
              <ValidationErrorMessage touched={touched} errorMessage={error} />
            </>
          );
        },
        id: "forsikringsselskabId",
        label: "Forsikringsselskab",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "policeNr",
        label: "Policenr.",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeFraDato",
        label: "Startdato",
        isRequired: true,
        initialValue: "",
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        label: "Slutdato",
        initialValue: "",
      },
      {
        component: "boolean",
        id: "garantiordning",
        label: "Garantiordning",
        initialValue: true,
      },
      {
        component: "boolean",
        id: "restance",
        label: "Restance",
        initialValue: false,
      },
      {
        component: "textarea",
        id: "notat",
        label: "Bemærkning",
        initialValue: "",
      },
    ],
    get: query + personForsikringId,
    post: (body) => {
      return {
        body: {
          ...body,
          periodeFraDato: body.periodeFraDato
            ? stringDateToyyyyMMdd(body.periodeFraDato)
            : null,
          periodeTilDatoInklusiv: body.periodeTilDatoInklusiv
            ? stringDateToyyyyMMdd(body.periodeTilDatoInklusiv)
            : null,
        },
        query,
      };
    },
    patch: (body) => {
      body = {
        ...body,
        // periodeTilDatoInklusiv:
        //   body.periodeTilDatoInklusiv === null ? "9999-12-31" : body.periodeTilDatoInklusiv,
      };
      return {
        body: JSON.stringify(getPatchOperations(body)),
        query: query + personForsikringId,
      };
    },
    delete: () => {
      return {
        query: query + personForsikringId,
      };
    },
  };
};
